import { Ban, Check, Plus } from 'lucide-react';
import React from 'react';
import { useNavigate, useParams } from 'react-router';

import { TableComponent, ReactColumn } from '@components/table';
import { Button } from '@components/ui/button';

import { CompositePointDefinitionDto } from '@api/FitnessActivityClient';
import { links } from '@core/router';

import { DeletePointDefinitionDialog } from './delete-dialog';
import { usePointDefinitionsStore } from './store';

const columns: ReactColumn<CompositePointDefinitionDto>[] = [
    {
        Header: 'Point Type Key',
        id: 'pointTypeKey',
        disableSortBy: true,
        accessor: (row) => (
            <span className="text-sm font-semibold">{row.pointTypeKey}</span>
        )
    },
    {
        Header: 'Label',
        id: 'label',
        disableSortBy: true,
        accessor: (row) => <span className="text-sm">{row.label}</span>
    },
    {
        Header: 'Enabled',
        id: 'enabled',
        disableSortBy: true,
        accessor: (row) => (
            <span className="flex items-center gap-1 text-sm">
                {row.enabled ? (
                    <Check className="size-4 text-success" />
                ) : (
                    <Ban className="size-4 text-muted-foreground" />
                )}
                {row.enabled ? 'Enabled' : 'Disabled'}
            </span>
        )
    },
    {
        Header: 'Rules',
        id: 'ruleCount',
        disableSortBy: true,
        accessor: (row) => (
            <span className="text-sm">{row.sourceRules.length}</span>
        )
    }
];

export const CommunityPointDefinitions = () => {
    const { communityId } = useParams();
    const navigate = useNavigate();

    const communityIdNum = Number(communityId);
    const { definitions, refresh } = usePointDefinitionsStore(communityIdNum);

    if (isNaN(communityIdNum)) return null;

    const [deleteTarget, setDeleteTarget] =
        React.useState<CompositePointDefinitionDto | null>(null);

    return (
        <>
            <div className="mb-4 flex justify-end">
                <Button
                    onClick={() =>
                        navigate(
                            links.createCommunityPointDefinition(communityId)
                        )
                    }
                >
                    <Plus />
                    Create Definition
                </Button>
            </div>

            <TableComponent<CompositePointDefinitionDto[]>
                items={definitions}
                columns={columns}
                emptyText="No point definitions yet."
                contextMenu={[
                    {
                        label: 'Edit',
                        action: (row) =>
                            navigate(
                                links.editCommunityPointDefinition(
                                    communityId,
                                    String(row.id)
                                )
                            )
                    },
                    {
                        label: 'Delete',
                        action: (row) => setDeleteTarget(row)
                    }
                ]}
            />

            <DeletePointDefinitionDialog
                definition={deleteTarget}
                onClose={() => setDeleteTarget(null)}
                onSuccess={() => {
                    setDeleteTarget(null);
                    refresh();
                }}
            />
        </>
    );
};

export default CommunityPointDefinitions;
